
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/tag/[tagUrlId]",
      function () {
        return require("private-next-pages/article/tag/[tagUrlId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/tag/[tagUrlId]"])
      });
    }
  